import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { SignInResponse } from '../interface/auth.interface';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private httpClient = inject(HttpClient);

    public signIn(username: string, password: string): Observable<SignInResponse> {
        return this.httpClient.post<SignInResponse>(environment.api + 'sign-in', { username, password });
    }

    public changePassword(username: string, newPassword: string, sessionId: string): Observable<SignInResponse> {
        return this.httpClient.post<SignInResponse>(environment.api + 'new-password-challenge', { username, newPassword, sessionId });
    }

    public refreshToken(refreshToken: string): Observable<SignInResponse> {
        return this.httpClient.post<SignInResponse>(environment.api + 'refresh-token', { refreshToken: refreshToken });
    }
}
